<template>
  <div v-if="data">
    <div v-if="typeof(data) === 'object'"
         class="pa-1 grey"
         :class="`lighten-${4 + nested}`">
      <dl>
        <template v-for="key in Object.keys(data)">
          <dt style="width: auto; min-width: 100px" :key="`dt-${key}`">{{ key | startCase }}</dt>
          <dd :key="`dd-${key}`" class="px-2">
            <json-preview :nested="nested + 1" :data="data[key]" />
          </dd>
        </template>
      </dl>
    </div>
    <template v-else-if="Array.isArray(data)">
      <ol>
        <li v-for="i in data.length" :key="`config-array-${i}`">
          <json-preview :nested="nested + 1" :data="data[i]" />
        </li>
      </ol>
    </template>
    <template v-else>
      {{ data }}
    </template>
  </div>
</template>

<script>
export default {
  name: 'JsonPreview',
  props: {
    data: {
      required: true
    },
    nested: {
      type: Number,
      required: false,
      default: 0
    }
  },
  components: {
    JsonPreview: () => import('@/components/JsonPreview')
  }
}
</script>
